import { render } from "./PageFormKondisiKhusus.vue?vue&type=template&id=51ac306a"
import script from "./PageFormKondisiKhusus.vue?vue&type=script&lang=js"
export * from "./PageFormKondisiKhusus.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__